module.exports = __webpack_public_path__ + "img/image-02.ac6f6021.jpeg";